import axios from 'axios'
import { getToken } from './saohei'
const CONFIG = {
  // API服务器配置
  API_SERVER: {
    DEV: 'https://xiaoxiangs.laway.cn', // 本地
    PROD: 'https://xiaoxiangs.laway.cn'
  },
  LOCALE: 'zh' // set locale
}
export let config = {
  baseURL:
    process.env.NODE_ENV !== 'production'
      ? CONFIG.API_SERVER.DEV
      : CONFIG.API_SERVER.PROD,
  headers: {
    common: {
      Authorization: getToken() ? 'Guest ' + getToken() : ''
    }
  }
}

axios.interceptors.request.use(
  config => {
    if (window) {
      let token = getToken()
      if (token) {
        config.headers.Authorization = `Guest ${token}`
      }
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

export default axios.create(config)
